// extracted by mini-css-extract-plugin
export default {"root":"IconEmailAttention_root__8DKR5","marketplaceStroke":"IconEmailAttention_marketplaceStroke__mRtZ3","attentionStroke":"IconEmailAttention_attentionStroke__ZLNfC"};